// development
// export const baseUrl = 'http://localhost:8888'
// produkcija
// export const baseUrl = ''
export const baseUrl =
  process.env.NODE_ENV === 'development' ? 'http://localhost:8888' : ''

// ne ovde vise. stize sa servera
// export const paymentBaseUrl = 'https://test.oppwa.com'
